import React from 'react';
import { Box, useTheme } from '@mui/material';
import { instructionStyles } from './Instructions.styles';
import { instructionData } from './instructionData';

interface InstructionsProps {
  selectedSection?: string;
}

export const Instructions: React.FC<InstructionsProps> = ({ selectedSection }) => {
  const theme = useTheme();
  const styles = instructionStyles(theme);

  // Filter to show only selected section if provided
  const sectionsToShow = selectedSection
    ? instructionData.filter(instruction => instruction.title === selectedSection)
    : instructionData;

  return (
    <Box sx={styles.instructionContent}>
      {sectionsToShow.map((instruction, index) => (
        <div key={index} dangerouslySetInnerHTML={{ __html: instruction.document }} />
      ))}
    </Box>
  );
};
